export * from "./mensmagazine";

// MEN'S NON-NO関連定数定義
/** 連携名 */
export const MENS_NON_NO_LINKAGE_NAME = "MensNonno";
/** 画面パス */
export const MENS_NON_NO_PATH = "mens_nonno";
/** デフォルトコールバックURL */
export const MENS_NON_NO_DEFAULT_CALLBACK_URL = process.env.VUE_APP_MENS_NON_NO_DEFAULT_CALLBACK_URL;
/** 許容コールバックURL */
export const MENS_NON_NO_ACCEPT_CALLBACK_URLS = process.env.VUE_APP_MENS_NON_NO_ACCEPT_CALLBACK_URLS.split(",").map((url: string) => `^${url}(\\?.*)?$`);
/** サービス規約URL */
export const MENS_NON_NO_SERVICE_TERM_URL = process.env.VUE_APP_MENS_NON_NO_SERVICE_TERM_URL;
/** メールアドレスドメイン */
export const MENS_NON_NO_EMAIL_DOMAINS = [
    "mensnonno.jp",
    "mensnonno.sid.shueisha.co.jp",
];
/** 連携サブID */
export const MENS_NON_NO_LINKAGE_SUB_ID = 2;
/** コールバックURLの任意指定 */
export const MENS_NON_NO_IS_CALLBACK_OPTIONAL = true;
